"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = void 0;
/**
 *
 * @param str A string or undefined
 * @returns Undefined if str is undefined. The string with a capital first letter otherwise.
 */
const capitalizeFirstLetter = (str) => {
    if (!str) {
        return str;
    }
    return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
